import { useState, useEffect, useCallback } from "react";

const COOKIE_CONSENT_KEY = "gdzieschronisko_cookie_consent";

export const useCookieConsent = () => {
  const [hasConsent, setHasConsent] = useState<boolean | null>(null);

  useEffect(() => {
    const updateConsent = () => {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      setHasConsent(consent === "accepted");
    };
    
    // Initial check
    updateConsent();

    // Listen for storage changes (in case consent is given in another tab or component)
    window.addEventListener("storage", updateConsent);
    
    // Listen for custom events from CookieBanner
    window.addEventListener("cookie-consent-change", updateConsent);
    
    // Listen for reset event
    const handleReset = () => {
      setHasConsent(null);
    };
    window.addEventListener("cookie-consent-reset", handleReset);

    return () => {
      window.removeEventListener("storage", updateConsent);
      window.removeEventListener("cookie-consent-change", updateConsent);
      window.removeEventListener("cookie-consent-reset", handleReset);
    };
  }, []);

  const resetConsent = useCallback(() => {
    localStorage.removeItem(COOKIE_CONSENT_KEY);
    setHasConsent(null);
    window.dispatchEvent(new Event("cookie-consent-reset"));
  }, []);

  return { hasConsent, isLoading: hasConsent === null, resetConsent };
};
